// extracted by mini-css-extract-plugin
export default {"switcher":"LanguageSwitcher-module--switcher--c7d4e","link":"LanguageSwitcher-module--link--94bc1"};